module.exports = __webpack_public_path__ + "img/2.451a3c6d.png";